module.exports = __webpack_public_path__ + "img/sns_utube.0414a802.svg";